import * as semver from 'semver'

export const contractSupportsRecipient = ({
  contractVersion,
  contractStandard,
  salesType = 'Public',
}: {
  contractVersion?: string | null
  contractStandard?: 'ERC721' | 'ERC1155'
  salesType?: 'Public' | 'Presale'
}) => {
  if (!contractStandard || !contractVersion) {
    return false
  }

  // Try force-convert version format to semver format
  const semVerContractVersion = semver.coerce(contractVersion)?.raw
  if (!semVerContractVersion) return false

  if (contractStandard === 'ERC1155') {
    // 1155s have always supported recipients
    return true
  } else {
    if (salesType === 'Presale') {
      // 721 presales don't support recipients at all
      return false
    } else {
      // for 721 public sales, purchaseWithRecipient was added in 13.0.0
      return semver.gte(semVerContractVersion, '13.0.0')
    }
  }
}
